<div class="header">
  <div class="smallPage">
    <img src="assets/login/logo2.png" width="103" alt="" class="mt-sm" />
  </div>
</div>
<div class="smallPage">
  <div class="page-name border-bottom-1 pl-xl fontBolder">密码设置</div>
  <div class="main-box">
    <ng-container *ngIf="type == 1">
      <div class="pl-md fontBolder text-md title-box mt-xl">首次登录星晨系统,请设置登录密码</div>
      <div class="flexRow mb-12">
        <label class="label">登录账号:</label>
        <input nz-input placeholder="请输入账号" class="width-338" disabled [(ngModel)]="user" />
        <div class="flexFull"></div>
      </div>
      <div class="flexRow mb-sm">
        <label class="label">登录密码:</label>
        <nz-input-group [nzSuffix]="suffixTemplate" class="width-338" [ngClass]="{ error: error.password }">
          <input
            maxlength="20"
            [type]="passwordVisible ? 'text' : 'password'"
            nz-input
            placeholder="请输入密码"
            [(ngModel)]="password"
            [maxLength]="20"
            (blur)="passwordBlur([password], 'password')"
          />
        </nz-input-group>
        <ng-template #suffixTemplate>
          <i nz-icon nzIconfont="icon_view" class="pointer" (click)="passwordVisible = !passwordVisible"></i>
        </ng-template>
        <div class="flexFull"></div>
      </div>
      <div class="flexRow mb-md">
        <label class="label"></label>
        <div class="text-gray1">建议密码长度为 8 ~20 位, 支持大小写字母及数字</div>
      </div>
      <div class="flexRow mb-sm">
        <label class="label">确认密码:</label>
        <nz-input-group [nzSuffix]="suffixTemplate2" class="width-338" [ngClass]="{ error: error.password2 }">
          <input
            maxlength="20"
            [type]="passwordVisible2 ? 'text' : 'password'"
            nz-input
            placeholder="请再次输入密码"
            [(ngModel)]="password2"
            [maxLength]="20"
            (blur)="passwordBlur([password2, password], 'password2')"
          />
        </nz-input-group>
        <ng-template #suffixTemplate2>
          <i nz-icon nzIconfont="icon_view" class="pointer" (click)="passwordVisible2 = !passwordVisible2"></i>
        </ng-template>
        <div class="flexFull"></div>
      </div>
      <div class="flexRow mt-xxl">
        <label class="label"></label>
        <button nz-button nzType="primary" (click)="setPassword()">完成</button>
      </div>
    </ng-container>
    <ng-container *ngIf="type == 2">
      <div class="mt-xl mb-xxl">
        <nz-steps [nzCurrent]="step">
          <nz-step nzTitle="手机号验证"></nz-step>
          <nz-step nzTitle="重置密码"> </nz-step>
          <nz-step nzTitle="完成"></nz-step>
        </nz-steps>
      </div>
      <div *ngIf="step == 0">
        <div class="flexRow mb-12">
          <label class="label">手机号码:</label>
          <input
            type="text"
            [(ngModel)]="mobile"
            nz-input
            maxlength="11"
            placeholder="请输入手机号"
            class="input-item login-form-item-input selfRadius width-338"
            [ngClass]="{ error: error_type == 'mobile' }"
            (keyup)="keyup()"
            (input)="checkForm()"
            (ngModelChange)="changeError('mobile')"
            [ngModelOptions]="{ standalone: true }"
          />
          <div class="flexFull"></div>
        </div>
        <div class="flexRow mb-12">
          <label class="label"></label>
          <div class="width-338" style="height: 32px">
            <com-slide-verify
              #slideVerifier1
              [initText]="'按住滑块，拖动到最右侧'"
              [sucessText]="'通过验证'"
              (sure)="sureSlider($event)"
            ></com-slide-verify>
          </div>
        </div>
        <div class="flexRow mb-xs" [ngStyle]="{ visibility: verifyShow ? 'visible' : 'hidden' }">
          <label class="label">验证码:</label>
          <input
            type="text"
            [(ngModel)]="verify"
            nz-input
            placeholder="请输入4位数字验证码 "
            style="width: 198px; margin-right: 8px"
            class="selfRadius"
            maxlength="4"
            (keyup)="keyup()"
            (input)="checkForm()"
            (ngModelChange)="changeError('verify')"
            [ngModelOptions]="{ standalone: true }"
          />
          <button style="width: 132px" class="text-sm" type="button" nz-button (click)="getCaptcha()" [disabled]="count > 0" nzBlock>
            {{ count ? count + '秒后重新获取' : countFirst == 1 ? '获取短信验证码' : '重新获取' }}
          </button>
          <div class="flexFull"></div>
        </div>
        <div class="flexRow">
          <label class="label"></label>
          <span *ngIf="count" class="width-338">验证码已发送到您的手机，有效期 5 分钟。</span>
        </div>
        <div class="flexRow mt-xl">
          <label class="label"></label>
          <button nz-button nzType="primary" class="login-button selfRadius" (click)="stepNext()">下一步</button>
        </div>
      </div>
      <div *ngIf="step == 1">
        <div class="flexRow mb-sm">
          <label class="label">新密码:</label>
          <nz-input-group [nzSuffix]="suffixTemplate3" class="width-338" [ngClass]="{ error: error.passwordNew }">
            <input
              maxlength="20"
              [type]="passwordNewVisible ? 'text' : 'password'"
              nz-input
              placeholder="请输入密码"
              [maxLength]="20"
              [(ngModel)]="passwordNew"
              (blur)="passwordBlur([passwordNew], 'passwordNew')"
            />
          </nz-input-group>
          <ng-template #suffixTemplate3>
            <i nz-icon nzIconfont="icon_view" class="pointer" (click)="passwordNewVisible = !passwordNewVisible"></i>
          </ng-template>
          <div class="flexFull"></div>
        </div>
        <div class="flexRow mb-md">
          <label class="label"></label>
          <div class="text-gray1">建议密码长度为 8 ~20 位, 支持大小写字母及数字</div>
        </div>
        <div class="flexRow mb-sm">
          <label class="label">确认密码:</label>
          <nz-input-group [nzSuffix]="suffixTemplate4" class="width-338" [ngClass]="{ error: error.passwordNew2 }">
            <input
              maxlength="20"
              [type]="passwordNewVisible2 ? 'text' : 'password'"
              nz-input
              placeholder="请再次输入密码"
              [maxLength]="20"
              [(ngModel)]="passwordNew2"
              (blur)="passwordBlur([passwordNew2, passwordNew], 'passwordNew2')"
            />
          </nz-input-group>
          <ng-template #suffixTemplate4>
            <i nz-icon nzIconfont="icon_view" class="pointer" (click)="passwordNewVisible2 = !passwordNewVisible2"></i>
          </ng-template>
          <div class="flexFull"></div>
        </div>
        <div class="flexRow mt-xxl">
          <label class="label"></label>
          <button nz-button nzType="primary" (click)="passwordNewOk()">确认</button>
          <div class="flexFull"></div>
        </div>
      </div>
      <div *ngIf="step == 2" class="text-center">
        <img src="assets/login/ok.png" width="302" alt="" />
        <div class="mt-50 text-20 fontBolder">密码重置成功</div>
        <div class="mt-md text-gray1">今后将使用新密码登录星晨系统,请妥善保管好您的密码!</div>
        <button nzType="primary" nz-button class="mt-40" routerLink="/passport/login">直接登录</button>
      </div>
    </ng-container>
    <ng-container *ngIf="type == 3">
      <div class="pl-md fontBolder text-md title-box mt-xl">首次请关联手机号</div>
      <div class="flexRow mt-100 mb-12">
        <label class="label">手机号码:</label>
        <input
          type="text"
          [(ngModel)]="mobile"
          nz-input
          maxlength="11"
          placeholder="请输入手机号"
          class="input-item login-form-item-input selfRadius width-338"
          [ngClass]="{ error: error_type == 'mobile' }"
          (keyup)="keyup()"
          (input)="checkForm()"
          (ngModelChange)="changeError('mobile')"
          [ngModelOptions]="{ standalone: true }"
        />
        <div class="flexFull"></div>
      </div>
      <div class="flexRow mb-12">
        <label class="label"></label>
        <div class="width-338" style="height: 32px">
          <com-slide-verify
            #slideVerifier1
            [initText]="'按住滑块，拖动到最右侧'"
            [sucessText]="'通过验证'"
            (sure)="sureSlider($event)"
          ></com-slide-verify>
        </div>
      </div>
      <div class="flexRow mb-xs" [ngStyle]="{ visibility: verifyShow ? 'visible' : 'hidden' }">
        <label class="label">验证码:</label>
        <input
          type="text"
          [(ngModel)]="verify"
          nz-input
          placeholder="请输入4位数字验证码 "
          style="width: 198px; margin-right: 8px"
          class="selfRadius"
          maxlength="4"
          (keyup)="keyup()"
          (input)="checkForm()"
          (ngModelChange)="changeError('verify')"
          [ngModelOptions]="{ standalone: true }"
        />
        <button style="width: 132px" class="text-sm" type="button" nz-button (click)="getCaptcha()" [disabled]="count > 0" nzBlock>
          {{ count ? count + '秒后重新获取' : countFirst == 1 ? '获取短信验证码' : '重新获取' }}
        </button>
        <div class="flexFull"></div>
      </div>
      <div class="flexRow">
        <label class="label"></label>
        <span *ngIf="count" class="width-338">验证码已发送到您的手机，有效期 5 分钟。</span>
      </div>
      <div class="flexRow mt-xl">
        <label class="label"></label>
        <button nz-button nzType="primary" class="login-button selfRadius" (click)="relationOk()">确认关联</button>
      </div>
    </ng-container>
  </div>
</div>
